import { makeStyles } from 'tss-react/mui';

type StyleParams = {
  isM1Enabled: boolean;
};

/**
 * Styles for the persistent AI disclaimer banner. Matches the
 * GA-Sidekick Figma "disclaimer" instance (`17553:78227`): a full-width
 * strip with a `grey/100 #f0f1f5` background, 4px vertical padding
 * (`spacing.xsmall`), centered `#525e6d` (`textSecondary`) caption text.
 */
const useStyles = makeStyles<StyleParams>()((theme, { isM1Enabled }) => ({
  banner: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: isM1Enabled ? 'transparent' : theme.new.color.grey[100],
    paddingTop: isM1Enabled ? 0 : theme.new.spacing.xsmall,
    paddingBottom: isM1Enabled ? 0 : theme.new.spacing.xsmall,
  },
  text: {
    color: theme.new.color.textSecondary,
    textAlign: 'center',
  },
}));

export default useStyles;
